import React from 'react';

function RenderCardBody(props) {
  const { children } = props;
  return <div>{children}</div>;
}

export default RenderCardBody;
